'use strict';

const h = require('phy');
const VariablePricingNew = require('./variable_pricing_new');
const VariablePricingRepeat = require('./variable_pricing_repeat');

const VariablePricing = props => {
  const { variablePricing } = props;

  if (!variablePricing) {
    return null;
  }

  const { pricingMetadata } = variablePricing;

  return pricingMetadata.offerType === 'VARIABLE_PRICING_NEW'
    ? h(VariablePricingNew, variablePricing)
    : h(VariablePricingRepeat, variablePricing);
};

module.exports = VariablePricing;
